import axios from 'axios';

export const getCount = async () => {
  return axios.get('/ordergrid/shipmentmode/statuses');
};
